import * as React from "react";
import { PulseLoader } from "react-spinners";
import styled from "styled-components";

export interface ISaveInProgressStateProps {
  firstFetch: boolean;
  inProgress: boolean;
}

const FixedMessage = styled.div(
  ({ theme }) => `
  position: fixed;
  background-color: ${theme.colors.lightgrey};
  color: #999;
  right: 1em;
  bottom: 1em;
  padding: 0.5em 1em;
  font-size: 1.3em;
  white-space: nowrap;
  z-index: 1;
`
);

const SaveInProgress: React.SFC<ISaveInProgressStateProps> = props => {
  const { firstFetch, inProgress } = props;

  if (firstFetch || !inProgress) {
    return null;
  }

  return (
    <FixedMessage className="global-indicator">
      <span>
        Saving <PulseLoader color="#999" size={4} />
      </span>
    </FixedMessage>
  );
};

export default SaveInProgress;
